import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useImportFeideGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ feideGroupId, organizationId, parentGroupId, includeMembers }) =>
      authAPI.importFeideGroup(feideGroupId, organizationId, parentGroupId, includeMembers),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["feideGroups", variables.organizationId]);
        queryClient.invalidateQueries(["group"]);
        queryClient.invalidateQueries(["organizations"]);
      },
      onError: (error) => {
        console.error("Error while importing FEIDE group:", error);
      },
    }
  );
};
